export const teacherDashboardFr = {
  // Teacher Dashboard specific
  teacherHome: 'Accueil',
  quranTracking: 'Suivi Coran',
  studentProgress: 'Progrès Étudiants',
  teacherMessages: 'Messages',
  teacherHomePage: 'Page d\'Accueil',
  welcomeTeacher: 'Bienvenue Professeur',
  quranTrackingSubtitle: 'Suivi de la mémorisation et révision du Coran',
  totalStudents: 'Total Étudiants',
  monthlyRecords: 'Enregistrements Mensuels',
  averageGrade: 'Moyenne des Notes',
  unreadMessages: 'Messages Non Lus',
  quranTrackingTitle: 'Suivi de la Mémorisation du Coran',
  allStudents: 'Tous les Étudiants',
  addNewRecord: 'Ajouter un Enregistrement',
  noStudents: 'Aucun étudiant',
  noStudentsFilter: 'Aucun étudiant correspondant au filtre',
  noRecords: 'Aucun enregistrement disponible',
  studentProgressTitle: 'Progrès des Étudiants dans la Mémorisation du Coran',
  memorizationStats: 'Statistiques de Mémorisation',
  advancedStudents: 'Étudiants Avancés (15+ Hizb)',
  intermediateStudents: 'Étudiants Intermédiaires (5-14 Hizb)',
  beginnerStudents: 'Étudiants Débutants (moins de 5 Hizb)',
  messagesAndCommunication: 'Messages et Communication',
  addQuranRecord: 'Ajouter un Enregistrement Coran',
  editQuranRecord: 'Modifier l\'Enregistrement Coran',
  loadingStudents: 'Chargement de la liste des étudiants...',
  noStudentsAvailable: 'Aucun étudiant disponible',
  noStudentsRegistered: 'Aucun étudiant enregistré. Veuillez contacter l\'administrateur.',
  add: 'Ajouter',
  edit: 'Modifier',
  delete: 'Supprimer',
  cancel: 'Annuler',
  save: 'Enregistrer',
  confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet enregistrement ?',
  errorAddingRecord: 'Erreur lors de l\'ajout de l\'enregistrement',
  errorDeletingRecord: 'Erreur lors de la suppression de l\'enregistrement',
  errorUpdatingData: 'Erreur lors de la mise à jour des données',
  sessionExistsToday: 'Il existe déjà une session pour cet étudiant aujourd\'hui, voulez-vous modifier la session existante ?',
  reportSent: 'Rapport envoyé avec succès',
  errorSendingReport: 'Erreur lors de l\'envoi du rapport',
  quickReport: 'Rapport Rapide',
  reportType: 'Type de Rapport',
  reportMessage: 'Message',
  selectReportType: 'Sélectionner le Type de Rapport',
  backToHome: 'Retour à la Page d\'Accueil',
  progressPercentage: 'Pourcentage de Progrès',
  hizbSaved: 'Hizb Mémorisés',
  forNextSession: 'Pour la Prochaine Séance',
  previousSessions: 'Séances Précédentes',
  
  // Messages (shared with parent)
  parentMessages: 'Messages des Parents',
  noMessages: 'Aucun message',
  from: 'De:',
  
  // Message priorities
  priorityNormal: 'Normale',
  priorityHigh: 'Élevée',
  priorityUrgent: 'Urgente',
  
  // Report types
  reportTypeAssignment: 'Devoir',
  reportTypeProgress: 'Rapport de Progrès',
  reportTypeAchievement: 'Réussite Exceptionnelle',
  reportTypeConcern: 'Note Importante',
  
  // Sender types
  senderTeacher: 'Professeur',
  senderAdmin: 'Directeur',
  senderParent: 'Parent',
  
  // Common
  dateUnknown: 'Non spécifié',
  update: 'Actualiser',
  
  // Password change
  changePassword: 'Changer le mot de passe',
  oldPassword: 'Ancien mot de passe',
  newPassword: 'Nouveau mot de passe',
  confirmPassword: 'Confirmer le mot de passe',
  enterOldPassword: 'Entrez l\'ancien mot de passe',
  enterNewPassword: 'Entrez le nouveau mot de passe',
  confirmNewPassword: 'Confirmez le nouveau mot de passe',
  passwordChangedSuccess: 'Mot de passe changé avec succès',
  errorChangingPassword: 'Erreur lors du changement de mot de passe',
  passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
  passwordMismatch: 'Les mots de passe ne correspondent pas',
  fillAllFields: 'Veuillez remplir tous les champs',
  changing: 'Changement en cours...',
  student: 'Étudiant',
  studentLabel: 'Étudiant(e)',
  selectStudent: 'Sélectionner un étudiant',
  sendButton: 'Envoyer',
  messagePlaceholder: 'Écrivez votre message ici...',
  
  // Teacher Dashboard specific stats labels
  presentToday: 'Présents Aujourd\'hui',
  absentToday: 'Absents Aujourd\'hui',

  // New keys
  associationName: 'Association Al Falah',
  teacherBoardSubtitle: 'Tableau de bord Enseignant',
  welcomeTeacherFemale: 'Bienvenue Professeure',
  welcomeTeacherMale: 'Bienvenue Professeur',
  examScoresTab: 'Notes d\'Examens',
  replyToMessage: 'Répondre au Message',
  to: 'À',
  allAdmins: 'Tous les administrateurs',
  reportSentToAdmins: 'Le rapport sera envoyé à tous les administrateurs',
  reportSentToAdminsAndParent: 'Le rapport sera envoyé à tous les administrateurs et aux parents de l\'élève sélectionné',
  reportSentToStudentGuardians: 'Le rapport sera envoyé aux parents de cet élève',
  reportSentToAdminsAndGuardians: 'Le rapport sera envoyé à tous les administrateurs et aux parents de cet élève',
  addExamScore: 'Ajouter une note d\'examen',
  examDate: 'Date de l\'examen',
  subjectLabel: 'Matière',
  gradeLabel: 'Note (/20)',
  selectSubject: 'Choisir une matière',
  notSpecified: 'Non spécifié',
  optional: '(optionnel)',
  noSentMessages: 'Aucun message envoyé',
  noReceivedMessages: 'Aucun message reçu',
  sentMessages: 'Messages envoyés',
  receivedMessages: 'Messages reçus',
  administration: 'Administration',

  // ExamScoresTable keys
  gradeOutOf20: 'Note (/20)',
  date: 'Date',
  actions: 'Actions',
  noTestScores: 'Aucune note d\'examen enregistrée',
  addTestScoreHint: 'Cliquez sur "Ajouter une note d\'examen" pour en ajouter une',
  unknown: 'Inconnu',

  // MessageItem keys
  noSubject: 'Sans objet',
  replyBadge: 'Réponse',
  replyButton: 'Répondre',

  // Alert messages
  noPermissionAdd: 'Vous n\'avez pas la permission d\'ajouter une note',
  fillRequiredFields: 'Veuillez remplir tous les champs obligatoires',
  invalidGrade: 'Veuillez entrer une note valide entre 0 et 20',
  examScoreAdded: 'Note ajoutée avec succès',
  examScoreAddFailed: 'Échec de l\'ajout de la note',
  examScoreAddError: 'Une erreur est survenue lors de l\'ajout de la note',
  noPermissionDelete: 'Vous n\'avez pas la permission de supprimer une note',
  confirmDeleteScore: 'Êtes-vous sûr de vouloir supprimer cette note ?',
  examScoreDeleted: 'Note supprimée avec succès',
  examScoreDeleteFailed: 'Échec de la suppression de la note',
  examScoreDeleteError: 'Une erreur est survenue lors de la suppression de la note',
  selectStudentOrAdmin: 'Veuillez sélectionner un élève ou cocher Administration',
  selectStudentRequired: 'Veuillez sélectionner un élève',
  loadingDataError: 'Erreur lors du chargement des données',

  // Quran tracking - colonnes tableau séances précédentes
  quranTableDate: 'Date',
  quranTableNewHifz: 'Nouveau Hifz',
  quranTableOldMurajah: 'Murājaʿah ancien',
  quranTableNewMurajah: 'Murājaʿah nouveau',
  quranTableEvalNewHifz: 'Éval. Hifz',
  quranTableEvalOldMurajah: 'Éval. Murājaʿah ancien',
  quranTableEvalNewMurajah: 'Éval. Murājaʿah nouveau',
  quranTableNote: 'Note',
  quranTableHizb: 'Nb. Hizb',
  quranHizbLabel: 'hizb mémorisé',
  quranProgressLabel: 'Progression',
  quranProgressPercent: '% du Coran',
};

